export default __webpack_public_path__ + "static/media/ReportIcon.082fc7ff.svg";